import type { SherwinWilliamsSectionType } from '@paintscout/util/builder'
import createPartnerBlockModule from './createPartnerBlockModule'

// Sherwin Williams (v1 modules, reused 1:1 — see createPartnerBlockModule)
import ColorHelp from '../../../presentation/sections/partners/SherwinWilliams/ColorHelp'
import ColorSamples from '../../../presentation/sections/partners/SherwinWilliams/ColorSamples'
import PopularColors from '../../../presentation/sections/partners/SherwinWilliams/PopularColors'
import ColorOfTheYear from '../../../presentation/sections/partners/SherwinWilliams/ColorOfTheYear'
import TopColors from '../../../presentation/sections/partners/SherwinWilliams/TopColors'
import FinestWhitesNeutrals from '../../../presentation/sections/partners/SherwinWilliams/FinestWhitesNeutrals'
import ExpertCollections from '../../../presentation/sections/partners/SherwinWilliams/ExpertCollections'
import ExploreExterior from '../../../presentation/sections/partners/SherwinWilliams/ExploreExterior'
import ChipsToDoor from '../../../presentation/sections/partners/SherwinWilliams/ChipsToDoor'
import HottestColors from '../../../presentation/sections/partners/SherwinWilliams/HottestColors'
import FinestWhites from '../../../presentation/sections/partners/SherwinWilliams/FinestWhites'
import PeelNStick from '../../../presentation/sections/partners/SherwinWilliams/PeelNStick'
import MatchAPhoto from '../../../presentation/sections/partners/SherwinWilliams/MatchAPhoto'
import ScheduleConsultation from '../../../presentation/sections/partners/SherwinWilliams/ScheduleConsultation'
import UploadPhotos from '../../../presentation/sections/partners/SherwinWilliams/UploadPhotos'
import ColorVisualizer from '../../../presentation/sections/partners/SherwinWilliams/ColorVisualizer'
import ColorExpert from '../../../presentation/sections/partners/SherwinWilliams/ColorExpert'
import SampleColors from '../../../presentation/sections/partners/SherwinWilliams/SampleColors'
import DesignerColorCollection from '../../../presentation/sections/partners/SherwinWilliams/DesignerColorCollection'
import ColormixForecast from '../../../presentation/sections/partners/SherwinWilliams/ColormixForecast'

/**
 * v2 registrations for the Sherwin-Williams partner-content blocks (#21311).
 * Keyed by `SherwinWilliamsSectionType` (the canonical list in
 * `@paintscout/util/.../sherwin-williams-block-types.ts`), so adding a type there without a
 * component registration here is a compile error. Every SW type is covered so that legacy docs
 * and v1→v2 converted docs all render in v2. Benjamin Moore (`benjamin-moore-main`) is
 * deliberately excluded — it's stale/unused and stays v1-only.
 */
const partnerBlocks: Record<SherwinWilliamsSectionType, ReturnType<typeof createPartnerBlockModule>> = {
  'sherwin-williams-popular-colors': createPartnerBlockModule(PopularColors),
  'sherwin-williams-color-of-the-year': createPartnerBlockModule(ColorOfTheYear),
  'sherwin-williams-top-colors': createPartnerBlockModule(TopColors),
  'sherwin-williams-finest-whites-neutrals': createPartnerBlockModule(FinestWhitesNeutrals),
  'sherwin-williams-expert-collections': createPartnerBlockModule(ExpertCollections),
  'sherwin-williams-explore-exterior': createPartnerBlockModule(ExploreExterior),
  'sherwin-williams-color-samples': createPartnerBlockModule(ColorSamples),
  'sherwin-williams-chips-to-door': createPartnerBlockModule(ChipsToDoor),
  'sherwin-williams-hottest-colors': createPartnerBlockModule(HottestColors),
  'sherwin-williams-finest-whites': createPartnerBlockModule(FinestWhites),
  'sherwin-williams-peel-n-stick': createPartnerBlockModule(PeelNStick),
  'sherwin-williams-color-help': createPartnerBlockModule(ColorHelp),
  'sherwin-williams-upload-photo': createPartnerBlockModule(UploadPhotos),
  'sherwin-williams-schedule-consultation': createPartnerBlockModule(ScheduleConsultation),
  'sherwin-williams-match-a-photo': createPartnerBlockModule(MatchAPhoto),
  'sherwin-williams-paint-color-visualizer': createPartnerBlockModule(ColorVisualizer),
  'sherwin-williams-color-expert': createPartnerBlockModule(ColorExpert),
  'sherwin-williams-sample-colors': createPartnerBlockModule(SampleColors),
  'sherwin-williams-designer-color-collection': createPartnerBlockModule(DesignerColorCollection),
  'sherwin-williams-colormix-forecast': createPartnerBlockModule(ColormixForecast)
}

export default partnerBlocks
